module.exports = __webpack_public_path__ + "img/hatchability.38a04d6b.svg";